import styled from "styled-components";

export const IntegrationsIconListWrapperStyled = styled.div`
  display: flex;
  margin-right: 5px;
  white-space: nowrap;
  align-items: center;
  z-index: 2;
`;

export const StyledArrowRightIcon = styled.div`
  padding: 15px 7px;
`;

export const StyledIconWrapper = styled.div`
  width: 38px;
  min-width: 38px;
  height: 38px;
  border: 1px solid #e9e9e9;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;

  &:hover {
    border: 1px solid #c8c9c7;
  }
`;

export const ExpandedContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const AnimatedIconWrapper = styled(StyledIconWrapper)<{
  isHovered: boolean;
  isAnimated: boolean;
}>`
  margin-right: ${({ isAnimated, isHovered }) =>
    isAnimated && isHovered ? -5 : -10}px;
  transition: margin 300ms;
`;

export const RestContainer = styled.div<{ isHovered: boolean }>`
  display: flex;
  position: absolute;
  left: ${({ isHovered }) => (isHovered ? 109 : 102)}px;
`;

export const RestAnimatedIcon = styled(StyledIconWrapper)<{
  isHovered: boolean;
  isAnimated: boolean;
}>`
  margin-right: ${({ isAnimated, isHovered }) =>
    isAnimated && isHovered ? -5 : -38}px;
  transition: margin 300ms;
`;

export const HiddenIconsWrapper = styled(StyledIconWrapper)<{
  isHovered: boolean;
}>`
  margin-right: -10px;
  position: absolute;
  left: 102px;
  visibility: ${({ isHovered }) => (isHovered ? "hidden" : "visible")};
  transition-property: visibility;
  transition-delay: ${({ isHovered }) => (isHovered ? "0" : "290ms")};
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #6b6b6b;
`;
